export default "__VITE_ASSET__9998d515__"